    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
    window.moment = require('moment');
    require('moment/locale/it');
    window.moment.locale('it');
    window.Vue = require('vue');
    require('./js/vue/filter')
    require('./js/vue/baseApp')
    require('tempusdominus-bootstrap-4');
    import ErrorInputComponent from './js/components/ErrorInputComponent.vue';
import DatePickerComponent from './js/components/DatePickerComponent.vue';
import TogglePanelComponent from './js/components/TogglePanelComponent.vue';
import TabsComponent from './js/components/TabsComponent.vue';
import PaginationComponent from './js/components/PaginationComponent.vue';
import ImgComponent from './js/components/ImgComponent.vue';
import FilePickerComponent from './js/components/FilePickerComponent.vue';
import FormGroupComponent from './js/components/FormGroupComponent.vue';
import ContattiComponent from './js/components/ContattiComponent.vue';
Vue.component('datepickercomponent', DatePickerComponent);
Vue.component('errorinputcomponent', ErrorInputComponent);
Vue.component('togglepanelcomponent', TogglePanelComponent);
Vue.component('tabscomponent', TabsComponent);
Vue.component('paginationcomponent', PaginationComponent);
Vue.component('imgcomponent', ImgComponent);
Vue.component('filepickercomponent', FilePickerComponent);
Vue.component('formgroupcomponent', FormGroupComponent);
Vue.component('contatticomponent', ContattiComponent);


require('../assets/bootstrap-4.5.3/dist/js/bootstrap.bundle.min.js');
require('./js/frontend/js/common/jquery.lazy.min.js');
require('./js/basehelper')
require('./js/prototype')
window.Swal = require('sweetalert2');
window.WOW = require('wow.js');
require('../assets/simplelightbox/simple-lightbox.min.js')


require('./js/frontend/js/contatti.js');
require('./js/frontend/js/windowload.js');
require('./js/frontend/js/common/typeahead.min.js');
require('./js/frontend/js/onready.js');
require('./js/frontend/js/onscroll.js');





